module.exports = __webpack_public_path__ + "media/Video 100.06e7c568.mp4";